import { createReducer } from 'AppSrc/core/reducers/create-reducer';
import {
  CREATE_UPDATE_CRQ_REQUEST,
  CREATE_UPDATE_CRQ_SUCCESS,
  CREATE_UPDATE_CRQ_ERROR,
  FETCH_CRQ_REQUEST,
  FETCH_CRQ_SUCCESS,
  FETCH_CRQ_ERROR,
} from 'AppSrc/core/crq/crq-actions';

const crqReducerDefaultState = {
  isFetching: false,
  isSaving: false,
  crqById: {},
};


const createUpdateCrqRequest = (state, action) => ({
  ...state,
  isSaving: true,
});

const createUpdateCrqSuccess = (state, action) => ({
  ...state,
  isSaving: false,
  crqById: {
    ...state.crqById,
    [action.payload.crqId]: action.payload.crqData,
  },
});

const createUpdateCrqError = (state, action) => ({
  ...state,
  isSaving: false,

});

const fetchCrqRequest = (state, action) => ({
  ...state,
  isFetching: true,
});

const fetchCrqSuccess = (state, action) => ({
  ...state,
  isFetching: false,
  crqById: {
    ...state.crqById,
    [action.payload.crqId]: action.payload.crqData,
  },
});

const fetchCrqError = (state, action) => ({
  ...state,
  isFetching: false,
});


// Action handlers dictionary
// defines the mapping between actions and the handler methods
const actionHandlers = {
  [CREATE_UPDATE_CRQ_REQUEST]: createUpdateCrqRequest,
  [CREATE_UPDATE_CRQ_SUCCESS]: createUpdateCrqSuccess,
  [CREATE_UPDATE_CRQ_ERROR]: createUpdateCrqError,
  [FETCH_CRQ_REQUEST]: fetchCrqRequest,
  [FETCH_CRQ_SUCCESS]: fetchCrqSuccess,
  [FETCH_CRQ_ERROR]: fetchCrqError,
};

// create the reducer
const crqReducer = createReducer(crqReducerDefaultState, actionHandlers);

export {
  crqReducerDefaultState,
  crqReducer,
};
